module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/logo_maestro.0e3ebe42.png";